import AnimatedFloatingButton from './AnimatedFloatingButton';
export default AnimatedFloatingButton;
